<app-page-header
  theme="light"
  icon="star-outline"
  [title]="'insurance.advantages.title' | translate"
>
</app-page-header>

<div class="mobile:px-5 px-10 bg-gray-100">
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section1.title' | translate }}</h6>
    <p>
      <span [innerHTML]="'insurance.advantages.section1.description' | translate: {minAmount: getMinAmount()}"></span>
    </p>
  </div>
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section2.title' | translate }}</h6>
    <p>
      <span [innerHTML]="'insurance.advantages.section2.description' | translate: {minMonthlyAmount: getMinMonthlyAmount()}"></span>
    </p>
  </div>
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section3.title' | translate }}</h6>
    <ul class="ml-6 mb-4 list-disc">
      <li><span [innerHTML]="'insurance.advantages.section3.list1' | translate"></span></li>
      <li><span [innerHTML]="'insurance.advantages.section3.list2' | translate"></span></li>
      <li><span [innerHTML]="'insurance.advantages.section3.list3' | translate"></span></li>
      <li><span [innerHTML]="'insurance.advantages.section3.list4' | translate"></span></li>
    </ul>
  </div>
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section4.title' | translate }}</h6>
    <p>
      <span [innerHTML]="'insurance.advantages.section4.description' | translate"></span>
    </p>
  </div>
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section5.title' | translate }}</h6>
    <p>
      <span>{{ 'insurance.advantages.section5.description' | translate }}</span>
    </p>
  </div>
  <div class="py-3 text-justify border-b">
    <h6 class="m-1 font-bold">{{ 'insurance.advantages.section6.title' | translate }}</h6>
    <p>
      <span>{{ 'insurance.advantages.section6.description' | translate: {insuranceAmount: getInsuranceAmount()} }}</span>
    </p>
  </div>

  <div class="py-10">
    <app-link (click)="goBack()" color="primary"><ion-icon name="arrow-back"></ion-icon> {{ 'shared.return'| translate }}</app-link>
  </div>
</div>
